import React, { Component } from "react";
import { Redirect } from 'react-router-dom'
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { Select, Typography, Mentions } from "antd";
import * as liveScheduleActions from '../../redux/actions/liveScheduleActions';

const { Text } = Typography;
const { Option } = Select;

class LiveSchedulesToggle extends Component {

  constructor(props) {
    super(props);

    this.state = {
      schedule: '',
      startDate: '',
      scheduleFormat: this.props.scheduleFormat || '',
      resourceName: '',
      resourceId: 0,
      toggleValueChange: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = async (value) => {
    let localStorageState = this.props.liveScheduleParameters;
    const { startDate, scheduleFormat, resourceCollectionName, resourceCollectionId } = localStorageState;

    if (value && value !== this.state.scheduleFormat && value !== scheduleFormat) {
      console.log(startDate)
      await this.props.actions.updateLiveScheduleParameters({startDate, scheduleFormat: value, resourceCollectionName, resourceCollectionId});

      let redirect;
      (value == 1 || value == 2) && (this.state.scheduleFormat == 7 || this.state.scheduleFormat == 9) ? redirect = true :
        (value == 7 || value == 9) && (this.state.scheduleFormat == 1 || this.state.scheduleFormat == 2) ? redirect = true : redirect = false;

      this.setState({
        startDate,
        scheduleFormat: value,
        resourceCollectionName,
        resourceCollectionId,
        toggleValueChange: true
      }, () => {
        this.props.onToggleChange(
          {
            redirect,
            scheduleFormat: value
          });
      });
    } else {
      //error handling
    }
  }

  render() {
    return (
      <React.Fragment>
        <Select defaultValue={this.state.scheduleFormat} style={{ width: 110, marginBottom: 20 }} onChange={this.handleChange}>
          <Option value={1}><Mentions style={{ border: 'none', fontWeight: 'bold' }} placeholder={'1-day'} /></Option>
          <Option value={2}><Mentions style={{ border: 'none', fontWeight: 'bold' }} placeholder={'2-day'} /></Option>
          <Option value={7}><Mentions style={{ border: 'none', fontWeight: 'bold' }} placeholder={'7-day'} /></Option>
          <Option value={9}><Mentions style={{ border: 'none', fontWeight: 'bold' }} placeholder={'9-day'} /></Option>
        </Select>
        {this.state.toggleValueChange && (
          <Redirect
            to={{
              pathname: (this.state.scheduleFormat === 1 || this.state.scheduleFormat === 2) ? '/live-schedule-view-short' : '/live-schedule-view-long',
            }}
          />
        )}
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    liveScheduleParameters: state.liveScheduleParameters
    // listPostedSchedules: state.listPostedSchedules
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      updateLiveScheduleParameters: bindActionCreators(
        liveScheduleActions.updateLiveScheduleParameters,
        dispatch
      )
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LiveSchedulesToggle)



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveSchedulesToggle.js